export default "__VITE_ASSET__ForDfutN__"